__turbopack_context__.v({
  "formPreloader": "FormStatus-module-scss-module__jb0bFq__formPreloader",
  "formStatus": "FormStatus-module-scss-module__jb0bFq__formStatus",
  "formStatus__contentWrapper": "FormStatus-module-scss-module__jb0bFq__formStatus__contentWrapper",
  "formStatus__icon": "FormStatus-module-scss-module__jb0bFq__formStatus__icon",
  "formStatus__subtitle": "FormStatus-module-scss-module__jb0bFq__formStatus__subtitle",
  "formStatus__textWrapper": "FormStatus-module-scss-module__jb0bFq__formStatus__textWrapper",
  "formStatus__title": "FormStatus-module-scss-module__jb0bFq__formStatus__title",
  "iconWrapper": "FormStatus-module-scss-module__jb0bFq__iconWrapper",
});
